export class ScoringParametrage {
  id: number | undefined;
  code: string;
  libelle: string;
  }